import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _i18nLabels;
import "core-js/modules/es.array.map.js";
export var AUTOMATIC = 'automatic';
export var MANUAL = 'manual';
var i18nLabels = (_i18nLabels = {}, _defineProperty(_i18nLabels, AUTOMATIC, 'mark_as_done_automatic'), _defineProperty(_i18nLabels, MANUAL, 'mark_as_done_manual'), _i18nLabels);
export var MODES = [AUTOMATIC, MANUAL].map(function (mode) {
  return {
    value: mode,
    i18nTitleKey: i18nLabels[mode]
  };
});
export function getModeI18nLabel(mode) {
  return i18nLabels[mode] || null;
}